export default __webpack_public_path__ + "static/media/bg_4.4290ed14.jpg";